import { strToU8, zipSync } from 'fflate'
import { Download } from 'lucide-react'
import { useState } from 'react'
import { useLazyGetAppArtifactsQuery } from '../services/projectDataApi'

export default function AppArtifactsDownload({ projectId, runId }: { projectId: string; runId?: string }) {
  const [load, { isFetching }] = useLazyGetAppArtifactsQuery()
  const [error, setError] = useState<string | null>(null)
  const download = async () => {
    setError(null)
    try {
      const bundle = await load({ projectId, ...(runId ? { runId } : {}) }).unwrap()
      const bytes = zipSync(Object.fromEntries(bundle.files.map(f => [f.path, strToU8(f.contents)])))
      const url = URL.createObjectURL(new Blob([new Uint8Array(bytes)], { type: 'application/zip' }))
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = 'app-tools-and-sightmap.zip'
      anchor.click()
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    } catch {
      setError('Could not download app tools and Sightmap. They may not be available yet; try again after QA finishes.')
    }
  }
  return <span>
    <button type="button" className="run-detail__back" disabled={isFetching} onClick={() => { void download() }}>
      <Download size={15} aria-hidden /> {isFetching ? 'Preparing download…' : `Download ${runId ? '' : 'latest '}app tools & Sightmap`}
    </button>
    {error && <span role="alert">{error}</span>}
  </span>
}
